import { ProgCss } from "./ProgCss.Generated";
import { cast } from "./tools";

export function WireUpMultiSelectionPopoverMenu(scopeEl: HTMLElement) {
    for (const el of scopeEl.querySelectorAll(`.${ProgCss.LijstContainer_checkbox} .${ProgCss.is_indented}`)) {
        const inputEl = cast(el, HTMLInputElement);
        inputEl.addEventListener("click", input => input.preventDefault()); // this isn't checkable; it's a target for a popover.
        inputEl.indeterminate = inputEl.checked; //cannot set indeterminate from html, so we encode that as checked (we happen never to want the checked state anyhow).
    }
}

export function WireUpColumnCheckBoxGroupToggle(scopeEl: HTMLElement) {
    for (const groupCheckbox of Array.from(scopeEl.getElementsByClassName(ProgCss.MultiSelect_groupToggle)).map(el => cast(el, HTMLInputElement))) {
        const groupDiv = cast(groupCheckbox.closest(`.${ProgCss.MultiSelectInput_itemGroup}`), HTMLElement);
        const otherCheckboxes = Array.from(groupDiv.querySelectorAll("input[type=checkbox]"))
            .map(el => cast(el, HTMLInputElement))
            .filter(el => el !== groupCheckbox);
        const syncGroupCheckBoxState = () => {
            const state = otherCheckboxes.map(el => el.checked as (boolean | null)).reduce((acc, checked) => acc === checked ? checked : null);
            groupCheckbox.checked = state === null ? groupCheckbox.checked : state;
            groupCheckbox.indeterminate = state === null;
        };
        syncGroupCheckBoxState();
        groupCheckbox.addEventListener("change", () => otherCheckboxes.forEach(otherCheckbox => otherCheckbox.checked = groupCheckbox.checked));
        groupDiv.addEventListener("change", syncGroupCheckBoxState);
    }
}

//TODO: keep types in sync with C#
type GenericLijstContents = {
    header: GenericLijstCell[],
    body: GenericLijstRow[],
};
type GenericLijstRow = {
    rowIndex: number,
    cells: GenericLijstCell[],
};
type GenericLijstCell = {
    text: string,
    cellIndex: number,
};


function toExportString(el: Element): string {
    return el.getAttribute('data-export-text-as') || [...el.childNodes].map(child =>
        child instanceof Text && el instanceof HTMLElement ? child.nodeValue || '' :
            child instanceof Element ? toExportString(child) :
                ''
    ).join('');
    //TODO: en data-export-tooltip dan?
}

function tableToData(tableEl: HTMLTableElement): GenericLijstContents {
    const header = [...tableEl.querySelectorAll(`:scope > thead > tr > th[data-pseudo_id='HeaderCell']`)]
        .map(th => cast(th, HTMLTableCellElement))
        .map((th, cellIndex) => ({ text: [th.getAttribute('data-smoke_group'), ''].filter(o => o != null).join('/') + (th.textContent || ''), cellIndex, }));
    const body = [...tableEl.querySelectorAll(':scope > tbody > tr[data-rowindex]')]
        .map(tr => cast(tr, HTMLTableRowElement))
        .map(tr => ({
            rowIndex: parseInt(tr.getAttribute('data-rowindex') || '', 10),
            cells: [...tr.querySelectorAll(`:scope > td[data-pseudo_id='RowCell']`)]
                .map(td => cast(td, HTMLTableCellElement))
                .map((td, cellIndex) => ({ text: toExportString(td) || '', cellIndex, })),
        }));
    return { header, body };
}

(window as any).tableToData_ForTest = tableToData;
